package uk.co.nickthecoder.kyd

/**
 * A [Stage] which automatically orders the [Actor]s by [Actor.zOrder].
 */
class ZOrderStage(name: String) : Stage(name) {

    override fun prepareDraw() {
        mutableActors.sortBy { it.zOrder }
    }

}
